export default __webpack_public_path__ + "static/media/s2.bafca66e.JPG";